import Vue from 'vue'
import VueRangedatePicker from 'vue-rangedate-picker'

Vue.use(VueRangedatePicker)



// WEBPACK FOOTER //
// ./src/front/init/components/range-datepicker.js